export default "__VITE_ASSET__cf381253__"